import * as httpService from '../httpService';
import { withEnterpriseId } from 'spark-state/stateUtil';
import { transform } from 'spark-util/fpUtils';
import { dateRange } from 'spark-util/commonUtils';
import { toQueryParamString } from 'spark-api/apiUtil';
import { appConfig } from '../../config/appConfig';

const gapPacketUrl = `${appConfig.SPARK_GAP_PACKET_DOMAIN}/gapPacket`;

const formatDistDate = transform({
    distributionDate: transform({
        start: dateRange,
        end: dateRange
    })
});

const formatDistributionDate = transform({
    start: dateRange,
    end: dateRange
});

export const getGapPacketList = withEnterpriseId(enterpriseId => query => {
    const page = (query && query.page) || 0;
    const size = (query && query.size) || 10;
    const sort = query && query.sort ? query.sort : 'distributedDate,desc' ;
    const distributionDateStartRange = (formatDistDate(query).distributionDate &&
                                formatDistDate(query).distributionDate.start) ||
                                '';
    const distributionDateEndRange = (formatDistDate(query).distributionDate &&
                                formatDistDate(query).distributionDate.end) ||
                                '';
    const gpTitle = query && query.gpTitle && query.gpTitle.value ? query.gpTitle.value : '';
    const orgName = query && query.org && query.org.orgName ? query.org.orgName : '';
    const siteNum = query && query.org && query.org.siteNum ? query.org.siteNum : '';
    const product = query && query.product && query.product.value ? query.product.value : '';
    const study = query && query.study && query.study.value ? query.study.value : '';
    const filterRequest = {
        'page': page,
        'size': size,
        'sort': sort,
        "gpTitle":gpTitle,
        "orgName":orgName,
        "siteNum": siteNum,
        "product":product,
        "studyName":study,
        "distStartDate":distributionDateStartRange,
        "distEndDate":distributionDateEndRange
    }  
    return httpService.get(
        `${gapPacketUrl}/management/listOfGapPacket/${enterpriseId}`,{
            queryParameters: {
                ...filterRequest
            }
        }
    );
});

export const getGapPacketSite = withEnterpriseId(enterpriseId => (search, product, studyId) => {
    return httpService.get(
        `${gapPacketUrl}/management/allSites/${enterpriseId}`,{
            queryParameters: {
                searchParam: search,
                product: product,
                studyId: studyId
            }
        }
    );
});

export const getGapPacketTitle = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${gapPacketUrl}/management/gapPackTitle/${enterpriseId}`, {
		queryParameters: {
			searchParam: query
		}
	})
);

export const getGapPacketTitleForRecipient = withEnterpriseId((enterpriseId) => (query) =>
	httpService.get(`${gapPacketUrl}/recipient/gapPackTitle/${enterpriseId}`, {
		queryParameters: {
			searchParam: query
		}
	})
);
export const createGapPacket = withEnterpriseId(enterpriseId => (slIds,product, protocolNum, org, distributionDate) => {
    const distributionDateStartRange = (formatDistributionDate(distributionDate) &&
                                formatDistributionDate(distributionDate).start) ||
                                '';
    const distributionDateEndRange = (formatDistributionDate(distributionDate) &&
                                formatDistributionDate(distributionDate).end) ||
                                '';
    const filterRequest = {
        "slIds":slIds,
        "org":org,
        "product":product,
        "study":protocolNum, //SAF-17987 - sending ProtocolNum instead of protocolId for PROD issue
        distributionDateStartRange,
        distributionDateEndRange
    } 
    return httpService.create(
        `${gapPacketUrl}/management/createGapPacket/${enterpriseId}`,
        JSON.stringify(filterRequest)
    );
});

export const getGapPacketListForRecipient = withEnterpriseId(enterpriseId => query => {
    const page = (query && query.page) || 0;
    const size = (query && query.size) || 10;
    const sort = query && query.sort ? query.sort : 'DISTRIBUTED_DT,desc' ;
    const status = (query && query.status) || 'Pending';
    const distributionDateStartRange = (formatDistDate(query).distributionDate &&
                                formatDistDate(query).distributionDate.start) ||
                                '';
    const distributionDateEndRange = (formatDistDate(query).distributionDate &&
                                formatDistDate(query).distributionDate.end) ||
                                '';
    const gpTitle = query && query.gpTitle && query.gpTitle.value ? query.gpTitle.value : '';
    const orgName = query && query.org && query.org.orgName ? query.org.orgName : '';
    const siteNum = query && query.org && query.org.siteNum ? query.org.siteNum : '';
    const product = query && query.product && query.product.value ? query.product.value : '';
    const studyName = query && query.study && query.study.value ? query.study.value : '';
    const filterRequest = {
        'status': status,
        "gpTitle":gpTitle,
        "orgName":orgName,
        "siteNum": siteNum,
        "product":product,
        "studyName":studyName,
        "distStartDate":distributionDateStartRange,
        "distEndDate":distributionDateEndRange
    }
    return httpService.create(
        `${gapPacketUrl}/recipient/gapPackts/${enterpriseId}${toQueryParamString({page,size,sort})}`, JSON.stringify({ ...filterRequest}) 
    );

});

export const acknowledgeGapPacket = withEnterpriseId((enterpriseId) => (gapPacketId) =>
	httpService.update(`${gapPacketUrl}/recipient/gapPacket/acknowledge/${enterpriseId}/${gapPacketId}`)
);